import { isFacets } from './isFacets'
import { isStorageAvailable } from './isStorageAvailable'

export function scrollToWithFiltered(href: string, scrollTo = false) {
  try {
    const newUrl =
      href?.indexOf(window?.location?.origin) !== -1
        ? href
        : `${window?.location?.origin}${href}`

    const urlRedirect = new URL(newUrl)
    const changePathName =
      urlRedirect?.pathname?.replaceAll('/', '') ===
      window?.location?.pathname?.replaceAll('/', '')

    if ((isFacets(href) || scrollTo) && changePathName) {
      const intervalExistsElement = setInterval(() => {
        const listElement = document?.querySelectorAll(
          '#productgrid, .blank-container'
        )

        if (listElement?.length && isStorageAvailable()) {
          const storageClickedProductId = document.getElementById(
            sessionStorage.getItem('clickedProductId') ?? ''
          )

          !storageClickedProductId && listElement?.[0]?.scrollIntoView(true)
          clearInterval(intervalExistsElement)

          return true
        }

        return false
      }, 10)
    }
  } catch (error) {
    console.error(error)
  }
}
